import { useQuery } from '@tanstack/react-query'
import { fetchDashboardStatsSummary } from '../api/overview'
import type { DashboardStatsSummary } from '../types'

export function useDashboardStats() {
  return useQuery<DashboardStatsSummary>({
    queryKey: ['dashboard-stats-summary'],
    queryFn: fetchDashboardStatsSummary,
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  })
}
